import React, { useEffect, useState, useContext } from "react";
import SOA from "../SOA";

const Help = () => {


};
export default Help;

export const buildData = (data,src) => {

   
    let PolCobs = [];
    let policy = {
        "Plan": data.idPlan,
        "SA": 0,
        "Prima": data.montoPagar,
        "Descuento": 0,
        "PrimaDE": 0,
        "PrimaNeta": data.montoPagar,
        "PrimaDE": 0,
        "PrimaExonerada": 0,
        "Impuesto": 0,
        "Total": data.montoPagar,
        "Estado": 0,
        "OpcionEntrega": data.esDelivery ? "Delivery" : "En sucursal",
        "EntregaPoliza": data.esDomicilio ? "Domicilio" : "Otra dirección",
        "DireccionEntrega": data.direccionEntrega,
        "Source": src
    };
    let Au = {
        "auMarca": data.marcaDesc.trim(),
        "auModelo": data.modeloDesc.trim(),
        "auAnio": data.anio,
        "auTipo": data.tarificacion.auTipo,
        "auCategoria": data.tarificacion.auCategoria,
        "auValorNuevo": data.tarificacion.auValorNuevo,
        "auNumPasajeros": data.tarificacion.auNumPasajeros,
        "auUso": data.tarificacion.usoo,
        "codigoMarca": data.marca,
        "codigoModelo": data.modelo,
        "auGPS": data.tarificacion.GPS,
        "auNuevo": data.tarificacion.auNuevo,
        "ideducible": data.tarificacion.dedu,
        "irastreoSatelital": data.tarificacion.rsat,
        "auPlaca": data.placa,
        "auMotor": data.numeroMotor,
        "auChasis": data.numeroChasis,
        "auColor": data.colorVehiculo,
        "auVin": data.numeroChasis,
        "auClaseveh": data.claseVehiculo
    };
    let Asegurado =
    {
        "TipoId": data.tipoIdentidad,
        "NumId": data.numeroIdentificacion,
        "Nombre": data.nombres,
        "Apellido": data.apellidos,
        "Direccion": data.direccionDomicilio,
        "Departamento": data.departamento,
        "Municipio": data.cuidad,
        "TelefonoCasa": data.telefonoCasa,
        "TelefonoCelular": data.telefonoPersonal,
        "Email": data.correoElectronico,
        "EstadoCivil": data.estadoCivil
    };
    data.catalogos.rates.forEach(element => {

        let titleRate = data.catalogos.coberturas.coverages.find(x => x.idCob == element.idCob);
        if (titleRate !== null) {
            element["Nombre"] = titleRate.nombre;
            element["orden"] = titleRate.orden;
        }
        element["mprimabruta"] = element.prima;
        element["PrimaGravada"] = 0;
        element["pdescuento"] = 0;
        element["mdescuento"] = 0;
        PolCobs.push(element);
    });


    policy["FormaPagos"] = "";

    if (!data.esTelepago) {
        if (data.nombreTarjeta !== null || data.nombreTarjeta !== '') {
            const date = data.expiracionTarjeta.split('/');
            let FormaPagos = {
                "Forma": "TARJ",
                "Nombre": data.nombreTarjeta,
                "Numero": data.numeroTarjeta,
                "VtoMes": date[0],
                "VtoAnio": date[1],
                "Cvv": data.cvvTarjeta,
                "Monto": data.montoPagar,
                "MonedaPago": "U$"
            }
            policy["CVV"] = data.cvvTarjeta;
            policy["FormaPagos"] = FormaPagos;
        }
    }



    policy["PolCobs"] = PolCobs;
    policy["Au"] = Au;
    policy["Asegurado"] = Asegurado;

    return policy;

};

export const buidDataOportunity = (data) => {
    let oportunity =
    {
        "TipoId": data.tipoIdentidad,
        "Identificacion": data.numeroIdentificacion,
        "Cedula": data.numeroIdentificacion,
        "Nombres": `${data.nombres} ${data.apellidos}`,
        "Email": data.correoElectronico,
        "Celular": data.telefonoPersonal,
        "Source": "SOA Online",
        "Importe": data.montoPagar
    }
    return oportunity;
}

export const buidDataPayment = (data, policyId) => {
    let payment =
    {
        CardNumber: data.numeroTarjeta,
        Cvv: data.cvvTarjeta,
        ExpirationDate: data.expiracionTarjeta,
        CardHolder: data.nombreTarjeta,
        PolicyId: policyId,
        AmountApp: data.montoPagar,
        CurrencyApp: 'U$'
    }
    return payment;
}

const createSOA = (data) => {
    const request = buildData(data);
};
/*
const getResume = (data) => {
    if (data.length === 0) return 0;
        return data.map(x => ({ ...x, prima: round(x.prima) + round((x.prima * x.pRecargo) / 100) })).sum('prima');
}*/

